import { Action, GeneralComplaintState, Product } from './types'

export const setSelectedProduct = (
    isProductUnknown: boolean | undefined,
    product?: Product
) => ({
    type: 'SET_SELECTED_PRODUCT',
    payload: {
        isProductUnknown,
        product,
    },
})

export const setGeneralComplaint = (
    {
        isBatchOrLotNumberKnown = '',
        batchOrLotNumber = '',
        wasProductPlaced = '',
        wasPatientInvolved = '',
        isReplacementNeeded = '',
        productType = '',
        wasOpenedOrDropped = '',
        wasAnotherImplantPlaced = '',
        productId = ''
    } = {} as GeneralComplaintState
) => ({
    type: 'SET_GENERAL_COMPLAINT',
    payload: {
        isBatchOrLotNumberKnown,
        batchOrLotNumber,
        wasProductPlaced,
        wasPatientInvolved,
        isReplacementNeeded,
        productType,
        wasOpenedOrDropped,
        wasAnotherImplantPlaced,
        productId
    },
})

const generalComplaintReducer: React.Reducer<GeneralComplaintState, Action> = (
    state: GeneralComplaintState,
    action: Action
) => {
    switch (action.type) {
        case 'SET_SELECTED_PRODUCT':
            return {
                ...state,
                isProductUnknown: action.payload.isProductUnknown,
                selectedProduct: {
                    ...action.payload.product,
                    salesOrg: action.payload.product.salesOrg || '' // Ensure salesOrg is always a string
                },
            }
        case 'SET_GENERAL_COMPLAINT':
            return {
                ...state,
                isBatchOrLotNumberKnown: action.payload.isBatchOrLotNumberKnown,
                batchOrLotNumber: action.payload.batchOrLotNumber,
                wasProductPlaced: action.payload.wasProductPlaced,
                wasPatientInvolved: action.payload.wasPatientInvolved,
                isReplacementNeeded: action.payload.isReplacementNeeded,
                productType: action.payload.productType,
                wasOpenedOrDropped: action.payload.wasOpenedOrDropped,
                wasAnotherImplantPlaced: action.payload.wasAnotherImplantPlaced,
                productID: action.payload.productId || state.productId,
                selectedProduct: {
                    ...state.selectedProduct,
                    productId: action.payload.productId || state.selectedProduct?.productId || '',
                    salesOrg: state.selectedProduct?.salesOrg || '',
                    productName: state.selectedProduct?.productName || '',
                    action: state.selectedProduct?.action || '',
                    validFrom: state.selectedProduct?.validFrom || '',
                    shortDescription: state.selectedProduct?.shortDescription || '',
                    materialPrice: state.selectedProduct?.materialPrice || '',
                    materialPriceCurrency: state.selectedProduct?.materialPriceCurrency || '',
                    categories: state.selectedProduct?.categories || null,
                    isDiscontinuedOrUnknown: state.selectedProduct?.isDiscontinuedOrUnknown ?? false,
                    isFirstPartyManufactured: state.selectedProduct?.isFirstPartyManufactured ?? false,
                }
            }

        default:
            return state
    }
}

export default generalComplaintReducer
